import VitOAuth from 'vit-oauth'
import fetchAvailabilityData from './fetchAvailability'
import {fetchCendynProfileUser} from './fetchCendynProfileUser'
import _ from 'lodash'
export const FETCH_AUTH_CODE_START = 'FETCH_AUTH_CODE_START'
export const FETCH_AUTH_CODE_SUCCESS = 'FETCH_AUTH_CODE_SUCCESS'
export const FETCH_AUTH_CODE_FAILURE = 'FETCH_AUTH_CODE_FAILURE'

export const fetchCendynLoginToken = (code, state) => async dispatch => {
	const config = {
		clientId: process.env.REACT_APP_CRM_API_APP_ID,
		redirectUri: process.env.REACT_APP_CRM_AUTH_REDIRECT_URL,
		authorizationEndpoint: process.env.REACT_APP_CRM_AUTH_PROVIDER_URL,
		tokenEndpoint: process.env.REACT_APP_CRM_PROVIDER_URL,
		requestedScopes: 'crm_user',
		supportsRefresh: false,
		crypto: window.crypto
	}

	const OAuthClient = new VitOAuth(config)

	dispatch({ type: FETCH_AUTH_CODE_START })
	return OAuthClient.getToken(code, state).then(token => {
		const accessToken = _.get(token, 'data.accessToken', null)

		if (token) {
			dispatch({
				type: FETCH_AUTH_CODE_SUCCESS,
				payload: token,
			})
			dispatch(fetchAvailabilityData(0))

			if (accessToken) {
				dispatch(fetchCendynProfileUser(accessToken))
			}
		} else {
			dispatch({
				type: FETCH_AUTH_CODE_FAILURE,
				payload: 'Invalid token response',
		})
			dispatch(fetchAvailabilityData(0))
			return Promise.reject()
		}
	})
}


// WEBPACK FOOTER //
// ./src/actions/fetchCendynLoginToken.js